import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const DayView = ({ date, appointments, providers, onAppointmentClick, onSlotClick }) => {
  const hours = Array.from({ length: 13 }, (_, i) => i + 8);

  const getAppointmentsForSlot = (providerId, hour) => {
    return appointments?.filter(apt => {
      const aptHour = new Date(apt.startTime)?.getHours();
      return apt?.providerId === providerId && aptHour === hour;
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed':
        return 'bg-success/10 border-success text-success';
      case 'pending':
        return 'bg-warning/10 border-warning text-warning';
      case 'cancelled':
        return 'bg-muted border-border text-muted-foreground';
      case 'completed':
        return 'bg-primary/10 border-primary text-primary';
      default:
        return 'bg-muted border-border text-foreground';
    }
  };

  return (
    <div className="overflow-x-auto">
      <div className="min-w-[800px]">
        <div className="grid grid-cols-[80px_repeat(auto-fit,minmax(200px,1fr))] border-b border-border">
          <div className="p-4 bg-muted font-medium text-sm text-foreground">Time</div>
          {providers?.map((provider) => (
            <div key={provider?.id} className="p-4 bg-muted border-l border-border">
              <div className="flex items-center gap-3">
                <Image
                  src={provider?.avatar}
                  alt={provider?.avatarAlt}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div className="min-w-0">
                  <p className="font-medium text-sm text-foreground truncate">{provider?.name}</p>
                  <p className="text-xs text-muted-foreground truncate">{provider?.specialty}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {hours?.map((hour) => (
          <div key={hour} className="grid grid-cols-[80px_repeat(auto-fit,minmax(200px,1fr))] border-b border-border min-h-[80px]">
            <div className="p-4 bg-muted/50 text-sm font-medium text-foreground">
              {hour === 12 ? '12:00 PM' : hour > 12 ? `${hour - 12}:00 PM` : `${hour}:00 AM`}
            </div>
            {providers?.map((provider) => {
              const slotAppointments = getAppointmentsForSlot(provider?.id, hour);
              return (
                <div
                  key={`${provider?.id}-${hour}`}
                  className="border-l border-border p-2 transition-smooth hover:bg-muted/30 cursor-pointer"
                  onClick={() => slotAppointments?.length === 0 && onSlotClick(provider?.id, hour)}
                >
                  {slotAppointments?.length === 0 ? (
                    <div className="flex items-center justify-center h-full text-xs text-muted-foreground">
                      Available
                    </div>
                  ) : (
                    <div className="space-y-2">
                      {slotAppointments?.map((apt) => (
                        <button
                          key={apt?.id}
                          onClick={(e) => {
                            e?.stopPropagation();
                            onAppointmentClick(apt);
                          }}
                          className={`w-full p-3 rounded-lg border text-left transition-smooth hover:shadow-md ${getStatusColor(apt?.status)}`}
                        >
                          <div className="flex items-start justify-between gap-2 mb-2">
                            <p className="font-medium text-sm truncate">{apt?.patientName}</p>
                            <span className="text-xs whitespace-nowrap">
                              {new Date(apt.startTime)?.toLocaleTimeString('en-US', { 
                                hour: 'numeric', 
                                minute: '2-digit' 
                              })}
                            </span>
                          </div>
                          <p className="text-xs opacity-90 truncate">{apt?.type}</p>
                          <div className="flex items-center gap-2 mt-2">
                            <Icon name="Clock" size={12} />
                            <span className="text-xs">{apt?.duration} min</span>
                          </div>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DayView;